export const REQUIRED = "Vui lòng nhập thông tin";

export const EMAIL_INVALID = "Vui lòng nhập đúng định dạng email";

export const NUMERIC = "Chỉ bao gồm số";

export const INRANGE = "Giá trị phải ở trong khoảng";

export const MAX_LENGTH = "Giá trị không được quá";

